module.exports = __webpack_public_path__ + "static/media/ikebukuro-hanakawado-3.11182cd9.jpg";